import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { BusinessAccountTypeNameMapping } from 'src/app/core/dtos/dto';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { BusinessAccountService } from 'src/app/core/services/business-account.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { selectBusinessAccountTypeNameMapping } from 'src/app/state/my-account.selectors';

@Component({
  selector: 'app-configure-notifications',
  templateUrl: './configure-notifications.component.html',
  styleUrls: ['./configure-notifications.component.scss']
})

export class ConfigureNotificationsComponent implements OnInit, OnDestroy {
  @ViewChild('confirmSaveNotification') confirmSaveNotification: ModalComponent;

  businessAccountTypeNameMapping$: Observable<BusinessAccountTypeNameMapping>;
  configNotificationModel: ConfigNotificationModel;
  notificationConfigSubscription: Subscription;
  saveNotificationConfigSubscription: Subscription;
  processing: boolean;
  modalTitle: string;
  modalBody: string;
  emailAlsoToParent: boolean;
  mailToParent: boolean;

  constructor(
    private store: Store,
    private businessAccountService: BusinessAccountService,
    private toastService: HotToastService
  ) { }

  ngOnInit(): void {
    this.businessAccountTypeNameMapping$ = this.store.pipe(select(selectBusinessAccountTypeNameMapping));
    this.refreshNotificationConfig();
  }

  refreshNotificationConfig() {
    this.notificationConfigSubscription = this.businessAccountService.getNotificationConfig()
      .subscribe(
        (result) => {
          this.configNotificationModel = result.content;
          this.mailToParent = this.configNotificationModel.mailToParent;
          this.emailAlsoToParent = this.configNotificationModel.emailAlsoToParent;
        },
        () => {
          this.toastService.warning("Unknown Error");
        });
  }

  cancelChanges() {
    this.refreshNotificationConfig();
  }

  saveNotificationConfig() {
    this.processing = true;
    this.configNotificationModel = {
      mailToParent: this.mailToParent,
      emailAlsoToParent: this.emailAlsoToParent
    };
    this.saveNotificationConfigSubscription = this.businessAccountService.saveNotificationConfig(this.configNotificationModel)
      .subscribe(
        () => {
          this.modalTitle = "Configuration Saved";
          this.modalBody = "Your notification configuration has been successfully saved";
          this.confirmSaveNotification.open();
          this.processing = false;
        },
        (error: HttpErrorResponse) => {
          this.processing = false;
          if (error.status !== 401) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            if (errorMessage?.reasons) {
              errorMessage.reasons.forEach(reasons => {
                this.toastService.warning(reasons.errorMessage);
              });
            }
            else {
              this.toastService.warning("Failed to save address information because of unknown problem. Please contact Paragon.");
            }
          }
        });
  }

  ngOnDestroy() {
    this.notificationConfigSubscription?.unsubscribe();
    this.saveNotificationConfigSubscription?.unsubscribe();
  }

}
